import { render, staticRenderFns } from "./FileXls.vue?vue&type=template&id=112f2feb&scoped=true"
import script from "./FileXls.vue?vue&type=script&lang=js"
export * from "./FileXls.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112f2feb",
  null
  
)

export default component.exports